var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_Uint8Array.js
// module id = 695
// module chunks = 168707334958949